import { useEffect } from "react";
import { googlePayConfiguration } from "./googlePay";
import { useTranslation } from "react-i18next";
import { Gpay } from "./googlePay";
import styles from './GooglePayInfo.module.scss';
import { getEnv } from "../../utils/getEnv";
import { Logs } from '../../utils/logs';

export function GooglePayInfo({ paymentFailed, showMessage, paymentMethod, isFormSubmitted, setShowExternalPaymentError }) {

    const { t } = useTranslation('common');

    useEffect(() => {
        if(paymentMethod === 'google-pay') {
            const googlePayScriptTag = document.createElement("script");
            googlePayScriptTag.onload = () => onGooglePayLoaded(setShowExternalPaymentError);
            googlePayScriptTag.setAttribute('src', 'https://pay.google.com/gp/p/js/pay.js');
            googlePayScriptTag.async = 'async';

            if (document.getElementById("gpay")) {
                document.getElementById("gpay").innerHTML = "";
            }

            document.head.appendChild(googlePayScriptTag);
        }
    },[paymentMethod])

    return (
       <>
        {(showMessage && isFormSubmitted) ? <p>{t('proceeding-payment')}</p> : <p>{t('pay-with-google-pay')}</p> }
        {paymentFailed && <p className={styles.error}>{t('payment-failed-try-again')}</p>}
       </>
    )
}

export const onGooglePayLoaded = (setShowExternalPaymentError) => {
  // eslint-disable-next-line no-undef
  const googlePayClient = new google.payments.api.PaymentsClient({
    environment: getEnv() === "live" ? "PRODUCTION" : "TEST",
  });

  Gpay.SetGoogleClient(googlePayClient);
  googlePayClient
    .isReadyToPay(googlePayConfiguration())
    .then((response) => {
      try {
        if (response.result) {
          const googlePayButton = googlePayClient.createButton({
            onClick: () => {
              // Fix for Firefox styling issue where created GPay button overlays button render in Form component
              document.getElementById("gpay").click();
              // clear failed payment error
              setShowExternalPaymentError(false);
            },
            buttonType: "book",
          });
          document.getElementById("gpay").appendChild(googlePayButton);
        }
      } catch (err) {
        Logs.AddEvent(`Error when rendering GooglePay button: ${JSON.stringify(err)}`);
        console.error(`Error when rendering GooglePay button: ${err}`);
      }
    })
    .catch((err) => console.error("isReadyToPay err:", err));
};